// src/hooks/useTeamIndex.js
import { useState, useEffect } from 'react';
import { fetchCompetitionEventTeams } from '../api/api';

export function useTeamIndex(competitionName, selectedDate, step) {
  const [teamIndexList, setTeamIndexList] = useState({});

  useEffect(() => {
    if(!competitionName || !selectedDate) {
      return
    }

    fetchCompetitionEventTeams(selectedDate.id)
      .then(data => setTeamIndexList(data))
      .catch(console.error);
  }, [selectedDate, step]);

  return teamIndexList;
}
